import { useContext } from 'react';
import Localecontext from '../modules/context/localeContext.js';

export const useLocale = () => useContext(Localecontext);
